import {
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function UsersTableHead() {
  return (
    <TableHead>
      <TableRow className={shared.tableHeadRow}>
        <TableCell component="th" scope="col" className={shared.thCellUser}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            User
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            Role
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            Seat
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            Status
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" aria-label="Additional attributes" className={shared.thCellExtra} />
        <TableCell component="th" scope="col" align="right" aria-label="Row actions" className={shared.thCellActions} />
      </TableRow>
    </TableHead>
  )
}
